//region :: Imports ::
import {ReactElement} from 'react';
import {Badge, BadgeSeverityType} from 'primereact/badge';
import MComponent from '../Component';
import {isNullOrUndefined} from '../../Utils';

//endregion

/** */
export type MDropDownItem<TValue> = {
    label: string;
    value: TValue;
    badge?: string | number;
    badgeSeverity?: BadgeSeverityType;
}

/** */
type Props<TValue> = MDropDownItem<TValue> & {
    //  If the properties of MDropDownItem change review whether
    //  this type should continue to derive from MDropDownOption as
    //  we may not want its new properties exposed as propreties
    //  on the component.
    //
    //  Deriving from MDropDownItem is just a convenient way
    //  of reusing the props without duplicating them.
}

/** */
class MDropDownOption<TValue> extends MComponent<Props<TValue>> {

    /** */
    public render(): ReactElement {

        const hasBadge = !isNullOrUndefined(this.props.badge);
        const badgeSeverity = this.props.badgeSeverity ?? 'info';

        return (
            <div className="flex justify-content-between">
                <span>{this.props.label}</span>
                {hasBadge && <Badge value={this.props.badge} severity={badgeSeverity}/>}
            </div>
        );

    }

}

export default MDropDownOption;
